// extracted by mini-css-extract-plugin
export default {"checkAndLabel":"checkbox_checkAndLabel__ROjkg","check":"checkbox_check__1lmU3","label":"checkbox_label__wt5LW","error":"checkbox_error__H4G0E"};